module.exports = __webpack_public_path__ + "img/ico23.29d1492f.jpg";